import { EditorBlank } from '@picsart/design-system/components/EditorBlank';
import { EditorMiddleware } from '@picsart/design-system/components/EditorMiddleware';

import useStyles from './styles';
import type { AppLayoutProps } from './types';

const AppLayout = ({
  header,
  children,
  className,
  isMobile,
}: AppLayoutProps) => {
  const classes = useStyles();

  if (isMobile) {
    return (
      <EditorBlank
        __isRootEntryElement
        isFullHeight
        className={className}
        header={header}
        body={children}
      />
    );
  }

  return (
    <EditorMiddleware
      __isRootEntryElement
      className={className}
      slot={
        <div className={classes.desktop}>
          {header}
          {children}
        </div>
      }
    />
  );
};

export default AppLayout;
